import Vue, { CreateElement } from 'vue'
import { Component } from 'vue-property-decorator'

import { Button } from '@src/elements/button/button'
import SessionManager from '@src/lib/session_manager'
import { TERMS_FALLBACK_LOCALE } from '@src/util/constants'

@Component({
  computed: {
    locale () {
      return this.$store.state.i18n.locale
    }
  }
})
export default class DownloadLegalDocuments extends Vue {
  private locale: string

  constructor () {
    super()
  }

  async downloadTerms () {
    await this.downloadPdf('terms-of-use')
  }

  async downloadPrivacyPolicy () {
    await this.downloadPdf('privacy-terms')
  }

  render (h: CreateElement) {
    return <div class='member-account-wrapper'>
      <div class='btn-row download-row'>
        <Button class='download-btn' type='remove' label={this.$t('PAGE.MEMBERS.LEGAL.DOWNLOAD_TERMS_OF_USE')} click={this.downloadTerms}
                ref='downloadTerms' />
        <Button class='download-btn' type='remove' label={this.$t('PAGE.MEMBERS.LEGAL.DOWNLOAD_PRIVACY_POLICY')} click={this.downloadPrivacyPolicy}
                ref='downloadPrivacyPolicy' />
      </div>
    </div>
  }

  private async downloadPdf (filePrefix: string) {
    const token = SessionManager.Instance.getAuthToken()
    const headers = { 'Auth-Token': token }
    const localePath = `/assets/legal-docs/${filePrefix}_${this.locale.toLowerCase()}.pdf`
    const fallbackPath = `/assets/legal-docs/${filePrefix}_${TERMS_FALLBACK_LOCALE}.pdf`

    let response = await fetch(localePath, { headers })
    if (!response.ok) {
      response = await fetch(fallbackPath, { headers })
    }

    const blob = await response.blob()
    const blobUrl = URL.createObjectURL(blob)
    window.open(blobUrl)
    setTimeout(() => URL.revokeObjectURL(blobUrl), 0)
  }
}
